
export const BASE_URL = 'https://stg-deepdao-server.deepdao.io/';
// export const BASE_URL = 'http://localhost:5248';

// export const BASE_URL = 'http://localhost:80/';

export const DAO_LOGOS_BUCKET_BASE_URL = 'https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo';
export const API_KEY = 'ksdf3ksa-937slj3';
export const TURNSTILE_SECRET = ''; 
export const BACKOFICCE_URL = 'https://backoffice-server-stage.deepdao.io/';
export const IPFS_LOGO_URL = 'ipfs://';
export const IPFS_MAIN_URL = 'https://ipfs.io/ipfs/';
export const WEBSOCKET_URL = 'wss://stg-deepdao-server-ws.deepdao.io';
export const STARTER_MONTHLY_PLAN = 'P-1GM38806UR037444RM6JX5DA';
export const STARTER_QUARTERLY_PLAN ='P-4W252171V3348753DM7CXXGY';
// export const STARTER_YEARLY_PLAN = 'P-4PC20685RD4167150M6JX7MI';
export const PRO_MONTHLY_PLAN = 'P-1DR97193PB833264TM6JV7UQ';
export const PRO_QUARTERLY_PLAN = 'P-0P1111902W225122DM7CXX2A';
// export const PRO_YEARLY_PLAN = 'P-20431861KW2091742M6JW3ZQ';

export const DEEP_DAO_API = 'https://stg-deepdao-api.deepdao.io';
export const DEEP_DAO_API_PRO = 'https://stg-deepdao-api.deepdao.io/pro';
export const PAYPAL_CLIENT_ID = 'AYkf30R8-ja-C7_iNtllnk8hxvMH-wfnU5nAEhj3kTcEPkFRdzk2oZqHIx7e3ZTcayfkUeDpPq7QdsQ6';

